import LegalLayout from './landing/LegalLayout';

function PrivacyPolicy() {
  return (
    <LegalLayout title="Privacy Policy">
      <section>
        <h2>Introduction</h2>
        <p>
          This Privacy Policy explains what information our service collects
          and records, and how we use it. We take your privacy seriously.
        </p>
      </section>

      <section>
        <h2>Information We Collect</h2>
        <ul>
          <li>Chat messages and interactions with our AI system</li>
          <li>Basic usage data to improve our service</li>
          <li>Technical information necessary for the service to function</li>
        </ul>
      </section>

      <section>
        <h2>How We Use Your Information</h2>
        <p>We use the collected information for:</p>
        <ul>
          <li>Providing and maintaining our Service</li>
          <li>Improving and personalizing user experience</li>
          <li>Analyzing usage patterns to enhance our AI system</li>
          <li>Communicating with you about service-related matters</li>
        </ul>
      </section>

      <section>
        <h2>Data Protection</h2>
        <p>
          We use a range of security measures to keep your personal information
          safe. Your data sits behind secured networks, and only a small number
          of people with special access rights can reach it.
        </p>
      </section>

      <section>
        <h2>Your Rights</h2>
        <p>You have the right to:</p>
        <ul>
          <li>Access your personal data</li>
          <li>Correct inaccurate data</li>
          <li>Request deletion of your data</li>
          <li>Object to our processing of your data</li>
          <li>Data portability</li>
        </ul>
      </section>

      <section>
        <h2>Contact Information</h2>
        <p>
          If you have questions about this Privacy Policy, email us at{' '}
          <a href="mailto:emil.filip@efsoft.co.uk">emil.filip@efsoft.co.uk</a>
        </p>
      </section>

      <div className="legal-callout">
        <p>
          By using our service, you consent to this Privacy Policy and agree to
          its terms. If you have more questions about it, contact us at the
          address above.
        </p>
      </div>
    </LegalLayout>
  );
}

export default PrivacyPolicy;
